import { render, staticRenderFns } from "./cookie-policy.vue?vue&type=template&id=3cd7bf5a&"
import script from "./cookie-policy.vue?vue&type=script&lang=js&"
export * from "./cookie-policy.vue?vue&type=script&lang=js&"
import style0 from "./cookie-policy.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports